<script setup>
import axios from 'axios'
import { getUrlBaseV2, getUrlApiV1 } from '@/utils/index'
import { computed, defineEmits, reactive, ref, onMounted, onUnmounted, inject, watch } from 'vue'
import { LogoutIcon } from '@heroicons/vue/outline'
import { useStore } from 'vuex'
import { maintainerData } from '@/composables/useLayouts'
import { useChatStore } from '@/stores/chat'
import { useDialog } from 'primevue/usedialog';
import { useRouter } from 'vue-router'
import NavbarItem from '@/views/chat/components/NavbarItem.vue'
import Status from '@/views/chat/components/ClientSidebar/Status.vue'
import { useElementHover } from '@vueuse/core'
import OverlayPanel from 'primevue/overlaypanel';
import Dialog from 'primevue/dialog'
import { defineAsyncComponent } from 'vue'
import OmnichannelCallWidget from '@/components/chat/telephonyOmnichannel/OmnichannelCallWidget.vue'
import ChatmixCallWidget from '@/components/chat/chatmixCalls/ChatmixCallWidget.vue'
const TelephonyCallWidget = defineAsyncComponent(() => import('@/views/chat/pages/Dashboard/components/TelephonyCallWidget.vue'))
import 'primeicons/primeicons.css'
import { useSignature } from '@/stores/signatures'
import { useConfigurations } from '@/stores/configurations'
import Sidebar from 'primevue/sidebar'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import { notify } from '@kyvg/vue3-notification'

const vuexStore = useStore()
const store = useChatStore()
const configs = useConfigurations()
const userStore = useUsersStore()
const signature = useSignature()
const stateDash = computed(() => vuexStore.state.dash.dash.darkMode)
const router = useRouter()

const showBadge = ref(true)

const myHoverableElement = ref()
const isHovered = useElementHover(myHoverableElement)
const toggleSideBar = ref(false)
const op = ref();
const changeStatusModal = ref(false);

const businessId = computed(() => userStore.me.business_id)



//chat_block_dashboard

const blockDashboard = computed(() => {

    const hasAudit = userStore.getPermissions.includes("access_audit");
    const dashBlocked = configs.business.settings.chat_block_dashboard;

    if (hasAudit) { return false }

    return dashBlocked;

})

const showClients = computed(() => {

    return configs.business.settings.chat_manager_client;

})

onMounted(() => {

    const sleekPlanDate = localStorage.getItem('sleekPlanDate') ? new Date(localStorage.getItem('sleekPlanDate')) : ''
    if (sleekPlanDate && sleekPlanDate < new Date('11/03/2024')) {
        showBadge.value = false
    }


})

const emit = defineEmits(['togglePage', 'openConfig', 'changeTheme'])

const state =

    blockDashboard.value == true ?

        reactive({

            navigation: [
                { icon: 'uil:comment-alt-dots', to: 'chat.attendances.progress', active: false, name: 'Chat' },
                { icon: 'mi:bar-chart', to: 'chat.crm', active: true, name: 'CRM' }

                //{ icon: 'eye', to: 'chat.audit', active: false, name: 'Auditoria' },
            ],

        }) :
        reactive({

            navigation: [
                { icon: 'uil:estate', to: 'chat.dash.home', active: true, name: 'Dashboard' },
                { icon: 'uil:comment-alt-dots', to: 'chat.attendances.progress', active: false, name: 'Chat' },
                // { icon: 'tabler:layout-kanban', to: 'chat.dash.kanban', active: false, name: 'Kanban' },
                { icon: 'mi:bar-chart', to: 'chat.crm', active: true, name: 'CRM' }
                //{ icon: 'eye', to: 'chat.audit', active: false, name: 'Auditoria' },
            ],

        })

const togglePage = to => {
    emit('togglePage', to)

    state.navigation.forEach(menu => menu.active = menu.to === to)

}

const openConfig = () => emit('openConfig')

const changeTheme = () => {
    const theme = localStorage.getItem('theme')

    if (!theme || theme === 'light') {
        localStorage.setItem('theme', 'dark')
        document.documentElement.classList.add('dark')
    } else if (theme === 'auto') {
        localStorage.setItem('theme', 'dark')
        document.documentElement.classList.add('dark')
    } else if (theme === 'dark') {
        localStorage.setItem('theme', 'light')
        document.documentElement.classList.remove('dark')
    }

    vuexStore.commit('dash/USE_DARK_MODE')
}

function openUrl() {

    localStorage.setItem('sleekPlanDate', new Date())
    showBadge.value = false
    const link = document.createElement('a')
    link.href = "https://changelog-vmix.notion.site/Changelog-Vmix-ffef65a36d384352b73535fbefc75466"
    link.target = '_blank'
    link.rel = 'noopener noreferrer'
    link.click()
}

function backLink() {

    const link = document.createElement('a')
    link.href = window.origin + '/app/dash/home'
    link.click()

    // router.push({ name: 'dashboard.home' })

}

const dialog = useDialog();


const showIncidents = () => {

    dialog.open(Status, {
        data: {
            height: 300
        },
        props: {
            header: 'Incidentes',

            modal: true
        }
    });
}

const isResseler = computed(() => {

    return import.meta.env.VITE_APP_RESELLER == "true" ? true : false;

})


const toggle = (event) => {
    op.value.toggle(event);
}



const visibleTop = computed(() => {
    return false
    if (store().websocket.status == 'Disconnected') {

        return true
    }

})



import { useUsersStore } from '@/stores/users'
import photoDefault from '@/assets/images/no_user.jpeg'
import Avatar from 'primevue/avatar'


const user = computed(() => userStore.me)
const avatar = computed(() => userStore.me.photo != '' ? userStore.me.photo : photoDefault)
import Menu from 'primevue/menu'

const overlay_menu = ref();

const showmenu = (event) => {
    overlay_menu.value.toggle(event);
};

const selectedTag = ref();
const status = ref('online')

const setStatus = () => {
    const BASE = getUrlBaseV2()
    axios.post(BASE + '/chat/attendant/status', {
        "status": status.value,
        "tag_id": selectedTag.value?.id || null
    }).then((res) => {

        notify({
            type: 'success',
            title: 'Pronto',
            duration: 3000,
            text: 'Status alterado com sucesso',
        })

        userStore.user.online_status = status.value
        changeStatusModal.value = false;


    }).catch((err) => {

        console.log(err)
        if (err) {
            notify({
                type: 'error',
                title: 'Atenção',
                duration: 3000,
                text: err.response?.data?.message,
            })
        }
    });
}

const items = ref([
    {
        label: 'Alterar status',
        items: [
            {
                label: 'Online',
                code: 'online',
                color: 'bg-green-500',
                severity: 'success',
                command: () => {


                    status.value = 'online'
                    setStatus();
                }

            },
            {
                label: 'Ausente',
                code: 'busy',
                color: 'bg-orange-400',
                severity: 'warning',
                command: () => {

                    status.value = "busy"
                    changeStatusModal.value = true;
                }

            },
            {
                label: 'Offline',
                code: 'offline',
                color: 'bg-red-500',
                severity: 'danger',
                command: () => {
                    status.value = "offline"
                    changeStatusModal.value = true;
                }

            }
        ]
    }
]);


const currentDomain = computed(() => {

    return window.location.hostname === "vmix.chatmix.com.br";

})



let intervalId = null;

onMounted(() => {

    store().getClosedCount();


    intervalId = setInterval(() => {
        // Sua lógica a ser executada a cada 5 minutos
        store().getClosedCount();

    }, 5 * 60 * 1000); // 5 minutos em milissegundos
});

onUnmounted(() => {
    if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
    }
});

const canShowCRM = computed(() => {
    return businessId.value === 6
})

const filteredNavigation = computed(() => {
    return state.navigation.filter(item => {
        if (item.to === 'chat.crm') {
            return signature().signatureChat.features.includes('crm')
        }
        return true
    })
})


</script>

<template>
    <div>

        <Sidebar v-model:visible="visibleTop" header="Seu chat está desconectado" :dismissable="false" position="top"
            style="height: auto">

            <h1 class="text-xl font-weight-bold">Atenção. Sua conexão foi perdida ou seu chat está aberto em outra aba.
                Feche outras janela abertas do chat e atualize a página para continuar.</h1>


            <Button @click.prevent.stop="closeTab" class="mt-4" label="Usar o chat na janela atual" />
        </Sidebar>

        <header ref="myHoverableElement"
            class="fixed top-0 left-0 h-screen overflow-y-auto w-14 bg-white md:w-20 dark:bg-neutral-700 chat_transition   hover:shadow-2xl group z-30">
            <audio id="localStream" autoplay playsinline muted></audio>
            <audio id="remoteStream" autoplay playsinline></audio>
            <OmnichannelCallWidget />
            <ChatmixCallWidget />
            <div :class="[

                'flex-1 flex flex-col min-h-0 h-full bg-white bg-opacity-70  ',
                'chat_transition group-hover:bg-white group-hover:bg-opacity-50 backdrop-blur-md',
                'dark:bg-neutral-700 dark:group-hover:bg-neutral-700 dark:group-hover:bg-opacity-80'
            ]">
                <div class="flex-1">
                    <div class="w-full flex justify-center h-20 pt-2">

                        <div class="w-11 md:w-16 h-[56px] px-2 flex items-center justify-center ">
                            <img :src="maintainerData.logo_small" :alt="maintainerData.name"
                                :title="maintainerData.name">
                        </div>

                        <div class="hidden w-auto h-[56px] px-2 items-center  duration-75">
                            <img :src="maintainerData.logo_large" :alt="maintainerData.name"
                                :title="maintainerData.name" class="w-full h-[56px] dark:hidden">
                        </div>

                        <div class="hidden w-auto h-[56px] px-2 items-center duration-75">
                            <img :src="maintainerData.logo_dark" :alt="maintainerData.name" :title="maintainerData.name"
                                class="w-full h-[56px] hidden dark:block">
                        </div>

                    </div>

                    <nav aria-label="Sidebar" class="py-2 md:px-3 flex flex-col">
                        <NavbarItem v-for="item in filteredNavigation" :key="item.to" :counter="item.counter"
                            :icon="item.icon" :name="item.name" :to="{ name: item.to }" />

                        <NavbarItem v-if="showClients" icon="uil:users-alt" name="Clientes"
                            :to="{ name: 'chat.clients' }" />

                        <TelephonyCallWidget />

                    </nav>
                </div>


                <div>
                    <nav aria-label="Sidebar" class="md:px-3 mb-3 flex flex-col">
                        <NavbarItem :icon="stateDash ? 'uil:sun' : 'uil:moon'" :name="stateDash ? 'Modo claro' : 'Modo escuro'"
                            :use-active="false" @click.stop.prevent="changeTheme" />








                        <NavbarItem v-if="false" icon="uil:moon" name="Modo claro" :use-active="false"
                            @click.stop.prevent="changeTheme" />

                        <NavbarItem v-if="false" icon="uil:moon" name="Modo escuro" :use-active="false"
                            @click.stop.prevent="changeTheme" />

                        <NavbarItem v-if="false" icon="bell" name="Notificações" :use-active="false" />

                        <NavbarItem v-if="false" icon="sliders-v-alt" name="Preferências" :use-active="false"
                            @click.stop.prevent="store().togglePreferencesSlideOver" />

                        <NavbarItem :icon="store().soundAlert ? 'uil:bell' : 'uil:bell-slash'" name="Alerta sonoro"
                            :use-active="false" @click.stop.prevent="store().soundAlert = !store().soundAlert" />


                        <!-- <NavbarItem v-if="!isResseler" :badge="showBadge.toString()" icon="uil:bookmark"
                            name="Novidades" :use-active="false" @click.stop.prevent="openUrl" /> -->

                        <NavbarItem icon="uil:signout" name="Voltar à gestão"
                            class="text-red-500 dark:text-red-400 dark:hover:text-red-500" :use-active="false"
                            @click.stop.prevent="backLink" />



                        <div v-if="currentDomain || true" class="text-center border-t pt-2 my-3">

                            <Avatar :image="avatar" shape="circle" />

                            <p class="text-xs line-clamp-1 font-medium chat_transition group-hover:text-chat-dark dark:group-hover:text-white text_dark dark:text-gray-300">
                                {{ user.first_name }}
                            </p>
                        </div>


                    </nav>
                </div>
            </div>

            <div v-if="false" class="flex flex-col h-full">
                <div class="px-1 md:px-2">
                    <img alt="SITE_NAME" title="SITE_NAME" src="@/assets/images/logos/logo_compact.svg">
                </div>

                <nav class="flex-1 flex flex-wrap items-start pt-6">
                    <div class="flex flex-wrap w-full space-y-1 px-2">
                        <RouterLink v-for="(menu, key) in state.navigation" :key="key"
                            v-tooltip.right="menu?.tooltip || ''" to="#" :class="[
                                'flex items-center justify-center w-full p-2 rounded-md text-base font-medium text-chat-gray',
                                'group chat_transition outline-none hover:text-chat-primary focus:text-chat-primary',
                                'dark:text-gray-400 dark:hover:text-white dark:focus:text-chat-primary',
                                menu.active ? 'dark:hover:text-chat-primary' : 'dark:hover:text-white'
                            ]" @click.prevent.stop="togglePage(menu.to)">
                            <Unicon :name="menu.icon" :class="[
                                'shadow-lg outline-none shadow-transparent h-10 w-10 p-2 rounded-lg',
                                { 'chat_shadow text-chat-primary dark:text-chat-primary dark:bg-neutral-300': menu.active },
                                'chat_transition dark:focus:ring-white dark:focus:text-chat-primary',
                            ]" />
                        </RouterLink>
                    </div>
                </nav>

                <nav class="w-full flex items-center mb-3">
                    <div class="flex flex-wrap w-full space-y-1 px-2">
                        <RouterLink to="#" :class="[
                            'flex items-center justify-center w-full rounded-md text-base font-medium text-chat-gray',
                            'group chat_transition outline-none hover:text-chat-primary focus:text-chat-primary',
                            'dark:text-gray-400 dark:hover:text-white dark:hover:text-white dark:focus:text-white'
                        ]" @click.prevent.stop="changeTheme">
                            <Unicon v-if="stateDash" name="moon" class="h-10 w-9 p-2 rounded-lg chat_transition" />

                            <Unicon v-if="!stateDash" name="bright" class="h-10 w-9 p-2 rounded-lg chat_transition" />
                        </RouterLink>

                        <RouterLink v-tooltip.right="'Notificações'" to="#" :class="[
                            'flex items-center justify-center w-full rounded-md text-base font-medium text-chat-gray',
                            'group chat_transition outline-none hover:text-chat-primary focus:text-chat-primary',
                            'dark:text-gray-400 dark:hover:text-white dark:hover:text-white dark:focus:text-white'
                        ]" @click.prevent.stop="openConfig">
                            <Unicon name="bell" class="h-10 w-9 p-2 rounded-lg chat_transition" />
                        </RouterLink>

                        <RouterLink v-tooltip.right="'Ajustes da conta'" to="#" :class="[
                            'flex items-center justify-center w-full rounded-md text-base font-medium text-chat-gray',
                            'group chat_transition outline-none hover:text-chat-primary focus:text-chat-primary',
                            'dark:text-gray-400 dark:hover:text-white dark:hover:text-white dark:focus:text-white'
                        ]" @click.prevent.stop="openConfig">
                            <Unicon name="sliders-v-alt" class="h-10 w-9 p-2 rounded-lg chat_transition" />
                        </RouterLink>


                        <RouterLink v-tooltip.right="'Sair do chat'" to="#" :class="[
                            'flex items-center justify-center w-full rounded-md text-base font-medium text-red-400',
                            'group chat_transition outline-none hover:text-red-600 focus:text-red-600',
                        ]">
                            <LogoutIcon class="h-10 w-9 p-2 rounded-lg chat_transition" aria-hidden="true" />
                        </RouterLink>
                    </div>
                </nav>
            </div>
        </header>

        <Dialog v-model:visible="changeStatusModal" modal header="Alterar status" :style="{ width: '25rem' }">
            <span class="p-text-secondary block mb-5">Selecione o motivo para mudança de status</span>

            <div class="flex align-items-center gap-3 mb-5">
                <Dropdown v-model="selectedTag" :options="store().tagsUser" optionLabel="name"
                    placeholder="Selecione o motivo" class="w-full md:w-14rem" />

            </div>
            <div class="flex gap-2 w-full  justify-end mb-3">
                <Button type="button" label="Cancelar" severity="secondary" @click="changeStatusModal = false"
                    outlined></Button>
                <Button type="button" label="Salvar" @click="setStatus"></Button>
            </div>
        </Dialog>


    </div>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>